import path from "./path.js";
import math from "core/math";
/**
 * Draw a line between `start` and `end`.
 *
 * @public
 * @method drawLine
 * @memberof Drawing
 *
 * @param {CanvasRenderingContext2D} context
 * @param {HTMLElement} element - The DOM Element to draw on
 * @param {Object} start - `{ x, y } in either pixel or canvas coordinates.
 * @param {Object} end - `{ x, y }` in either pixel or canvas coordinates.
 * @param {Object} options - See {@link path}
 * @param {String} [coordSystem='pixel'] 
 * @returns {undefined}
 */
export default function drawLine(
  context,
  element,
  start,
  end,
  options,
  coordSystem = "pixel"
) {
  path(context, options, context => {
    if (coordSystem === "pixel") {
      start = math.coordinate.pixelToCanvas(element, start);
      end = math.coordinate.pixelToCanvas(element, end);
    }

    context.moveTo(start.x, start.y);
    context.lineTo(end.x, end.y);
  });
}
